<template>
<div>
  <div class="table__wrapper" v-if="referrals.length > 0">
    <table class="table is-fullwidth">
      <thead>
        <tr>
          <th class="is-4">ROLE</th>
          <th>HIRER</th>
          <th>SALARY</th>
          <th>REWARD IN VIBES</th>
          <th>REFERRALS</th>
          <th>HIRED</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(referral, index) in referrals" :key="index"
          v-on:click="onReferralClicked(referral)" class="clickable">
          <td class="is-4">{{ referral.title }}</td>
          <td>{{ referral.companyName }}</td>
          <td><job-salary :job="referral" /> </td>
          <td><reward :min="referrerRewardMin(referral)" :max="referrerRewardMax(referral)" :rewardPercentage="referral.rewardPercentage" cssClass="inline normal f-14" title="" :referrer="true" /></td>
          <td>{{ referral.referralCount }}</td>
          <td class="hired-count" :class="{'is-hired': referral.hiredCount > 0 }">
            {{ referral.hiredCount }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <empty-state v-else title="No Referrals">
    <template slot="content">To refer somebody either 1) Go to a <router-link to="/jobs">job</router-link> and click Refer Somebody OR 2) Go to <router-link to="/jobseekers">jobseeker's</router-link> <br/>profile and click Refer For Job. Let us know if you need support in Telegram.</template>
  </empty-state>
</div>
</template>

<script>
import Columns from '@/components/general/columns'
import Column from '@/components/general/column'
import Heading from '@/components/general/heading'
import JobSalary from '@/components/general/job-salary'
import EmptyState from '@/components/general/empty-state'
import Reward from '@/components/jobs/reward'
import RewardHelper from '@/helpers/reward'
import GlobalData from '@/helpers/global-data'

export default {
  name: 'RolesList',
  components: {
    Columns, Column, Heading, EmptyState, Reward, JobSalary
  },
  props: {
    referrals: {
      type: Array,
      required: true
    }
  },
  computed: {
    referralFraction () {
      return GlobalData.referralFraction()
    }
  },
  methods: {
    onReferralClicked (item) {
      this.$emit('select', item)
    },
    hiredCount (referral) {
      return referral.hiredCount
    },
    calcSalary (referral) {
      return JobSalary.methods.salary(referral)
    },
    referrerRewardMin (job) {
      const f = this.referralFraction
      return RewardHelper.user(job.minReward, job.rewardPercentage) * f
    },
    referrerRewardMax (job) {
      const f = this.referralFraction
      return RewardHelper.user(job.maxReward, job.rewardPercentage) * f
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

h6.heading {
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
}

.columns {
  margin: 0;
  padding: 0;
  .column {
    padding: 0 1rem;
  }
}

.columns:not(:last-child) {
  border-bottom: solid 1px #ddd;
}

.tbody {
  font-size: 0.875rem;
  background-color: white;
  border: solid 1px #ddd;
  border-radius: 4px;
  .columns {
    height: 3rem;
    align-items: center;
    cursor: pointer;
    &:hover {
      background-color: $hover-background;
      border-radius: 4px;
    }
  }
}

.status {
  font-weight: bold;
  letter-spacing: 2px;
  font-size: 0.75rem;
  color: $primary;
  text-transform: uppercase;
}

.hired-count {
  font-weight: bold;
}

.hired-count.is-hired {
  color: $brand-primary;
}

</style>



// WEBPACK FOOTER //
// src/components/referrals/roles-list.vue